/*
 * ct-cart-discount.js
 *
 * Kortingscode-veld in de cart drawer (snippets/ct-cart-discount.liquid).
 *
 * Toepassen/verwijderen via de Ajax Cart API:
 *   POST /cart/update.js  { discount: "CODE1,CODE2", sections, sections_url }
 * Dit VERVANGT de set codes op de cart (lege string = alles weg), dus we
 * sturen altijd de complete gewenste lijst. Het antwoord is het cart-object;
 * daarin meldt discount_codes[] per code of hij toepasbaar is
 * ({ code, applicable }). Een niet-toepasbare code halen we direct weer weg,
 * anders blijft hij stil op de cart hangen tot de checkout.
 *
 * `discount_codes` in het update.js-antwoord: BEVESTIGD in de browser
 * (QA 29-9): aanwezig met { code, applicable } na het toepassen; afwezig
 * als er geen codes meer op de cart staan. Ontbreekt het veld, dan gaan we
 * ervan uit dat de gestuurde lijst is aangenomen.
 *
 * EÉN ROUND TRIP (David, 29-9): elke aanroep vraagt de cart-sectie mee
 * (theme.cart.sectionParams(), zie assets/cart-api.js), net als de
 * aantalwijzigingen in cart-form.js. Het antwoord bevat dan de verse
 * markup; die geven we via het event 'cart:sections' aan cart-form.js,
 * dat hem toepast (applySections) en alleen bij ontbreken terugvalt op een
 * volledige herbouw. Daarvoor kostte elke code twee requests
 * (update.js + cart?view=ajax). theme.cart is een module en kan bij een
 * heel vroege klik nog ontbreken; dan gaat de aanroep zonder sections en
 * volgt de herbouw — nooit stil falen.
 *
 * ESCAPE (David, 29-9): Escape in een gevuld veld maakt het veld leeg en
 * gaat NIET door naar de drawer (die luistert op keyup op window en zou
 * anders dichtklappen terwijl de klant zijn code corrigeert). Escape in een
 * leeg veld laten we door: dan is sluiten de verwachte actie.
 *
 * CHIP: identiek aan het kortingscode-label op een regel
 * (snippets/cart-item.liquid): zelfde prijskaartje-icoon, zelfde
 * --ctChip*-stijl (ct-cart-drawer.css). ICON_TAG hieronder is hetzelfde SVG
 * als in cart-item.liquid en ct-cart-discount.liquid; wijzig alle drie.
 *
 * Enter in het veld wordt afgevangen: het veld staat in het cart-formulier
 * en Enter zou anders afrekenen.
 *
 * Bewust geen ES module (zie ct-gift-picker.js): <script defer> uit
 * snippets/preload-js.liquid.
 */
(function () {
  'use strict';

  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
  var ICON_TAG = '<svg class="ct-discount__chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.6 13.1l-7.5 7.5a1.6 1.6 0 0 1-2.3 0l-7.2-7.2a1.6 1.6 0 0 1-.5-1.1V4.7c0-.9.7-1.6 1.6-1.6h7.6c.4 0 .8.2 1.1.5l7.2 7.2a1.6 1.6 0 0 1 0 2.3z"></path><circle cx="7.8" cy="7.8" r="1.3"></circle></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sectionParams() {
    var t = window.theme;
    if (t && t.cart && typeof t.cart.sectionParams === 'function') {
      try { return t.cart.sectionParams(); } catch (e) { /* zonder sections verder */ }
    }
    return {};
  }

  function isEscape(evt) {
    return evt.key === 'Escape' || evt.key === 'Esc' || evt.keyCode === 27;
  }

  function init() {
    var root = document.querySelector('[data-ct-discount]');
    if (!root) return;

    var input = root.querySelector('[data-ct-discount-input]');
    var btn = root.querySelector('[data-ct-discount-apply]');
    var chips = root.querySelector('[data-ct-discount-codes]');
    var msg = root.querySelector('[data-ct-discount-msg]');
    var t = root.dataset;
    var codes = (t.codes || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    var busy = false;
    var swallowEscape = false;

    function showMsg(text) {
      msg.textContent = text || '';
      msg.hidden = !text;
    }

    function setBusy(on) {
      busy = on;
      root.classList.toggle('is-busy', on);
      btn.classList.toggle('btn--loading', on);
      btn.disabled = on;
    }

    function renderChips() {
      chips.innerHTML = codes.map(function (c) {
        return '<span class="ct-discount__chip">' +
          ICON_TAG +
          '<span class="ct-discount__chip-code">' + esc(c) + '</span>' +
          '<button type="button" class="ct-discount__chip-remove" data-ct-discount-remove="' + esc(c) + '" aria-label="' + esc(t.tRemove) + ' ' + esc(c) + '">' + ICON_CLOSE + '</button>' +
        '</span>';
      }).join('');
      chips.hidden = codes.length === 0;
    }

    function update(list) {
      var body = Object.assign({ discount: list.join(',') }, sectionParams());
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      });
    }

    /* Codes die de cart daadwerkelijk heeft aangenomen; zonder het veld
       (zie kop) de lijst die we zelf stuurden. */
    function acceptedCodes(cart, sent) {
      if (!cart || !Array.isArray(cart.discount_codes)) return sent;
      return cart.discount_codes.filter(function (d) { return d && d.applicable !== false; }).map(function (d) { return d.code; });
    }

    /* Verse markup naar cart-form.js; zonder sections in het antwoord valt
       die terug op een volledige herbouw. */
    function rebuild(cart) {
      document.dispatchEvent(new CustomEvent('cart:sections', {
        detail: { sections: cart && cart.sections ? cart.sections : null }
      }));
    }

    function apply() {
      if (busy) return;
      var code = (input.value || '').trim();
      if (!code) return;
      var exists = codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
      if (exists) { showMsg(t.tExists); return; }

      showMsg('');
      setBusy(true);
      var wanted = codes.concat([code]);

      update(wanted).then(function (cart) {
        var accepted = acceptedCodes(cart, wanted);
        var ok = accepted.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
        if (!ok) {
          /* Niet toepasbaar: terug naar de vorige set, anders blijft de code
             stil op de cart staan tot de checkout. De markup van dít
             antwoord is de juiste. */
          showMsg(t.tInvalid);
          return update(codes);
        }
        codes = accepted;
        input.value = '';
        return cart;
      }).then(function (cart) {
        renderChips();
        rebuild(cart);
      }).catch(function () {
        showMsg(t.tError);
      }).then(function () {
        setBusy(false);
      });
    }

    function remove(code) {
      if (busy) return;
      showMsg('');
      setBusy(true);
      var wanted = codes.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      update(wanted).then(function (cart) {
        codes = acceptedCodes(cart, wanted);
        renderChips();
        rebuild(cart);
      }).catch(function () {
        showMsg(t.tError);
      }).then(function () {
        setBusy(false);
      });
    }

    btn.addEventListener('click', function (evt) {
      evt.preventDefault();
      apply();
    });

    input.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter' || evt.keyCode === 13) {
        evt.preventDefault();
        apply();
        return;
      }
      if (isEscape(evt) && input.value !== '') {
        evt.preventDefault();
        evt.stopPropagation();
        input.value = '';
        showMsg('');
        /* De drawer sluit op keyup; die hoort bij deze keydown en moet dus
           ook worden tegengehouden. */
        swallowEscape = true;
      }
    });

    input.addEventListener('keyup', function (evt) {
      if (isEscape(evt) && swallowEscape) {
        swallowEscape = false;
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      }
    });

    input.addEventListener('input', function () {
      if (!msg.hidden) showMsg('');
    });

    chips.addEventListener('click', function (evt) {
      var b = evt.target.closest('[data-ct-discount-remove]');
      if (!b) return;
      evt.preventDefault();
      remove(b.getAttribute('data-ct-discount-remove'));
    });

    renderChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
